// Actions
export const REGISTER_NOTIFICATION = 'NOTIFICATIONS/REGISTER_NOTIFICATION'
export const NOTIFICATION_SEEN = 'NOTIFICATIONS/NOTIFICATION_SEEN'
export const NOTIFICATION_TOASTED = 'NOTIFICATIONS/NOTIFICATION_TOASTED'

// Commits
export const ADD_NOTIFICATION = 'NOTIFICATIONS/ADD_NOTIFICATION'
export const SET_NOTIFICATION_SEEN = 'NOTIFICATIONS/SET_NOTIFICATION_SEEN'
export const SET_NOTIFICATION_TOASTED = 'NOTIFICATIONS/SET_NOTIFICATION_TOASTED'
export const SET_NOTIFICATIONS = 'NOTIFICATIONS/SET_NOTIFICATIONS'
